export const facebookApp = {
	appId: '3117344658286828',
}
export const googleApp = {
	clientId:
		'655337669538-ej6hsrdllml9ss9fssjvhevfvs8dfqen.apps.googleusercontent.com',
}
